import * as React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import styles from './expandable-panel.scss';

import type { JSX } from "react";

interface ExpandablePanelComponentProps {
  title: string;
  isOpen?: boolean;
  children?: React.ReactNode;
}

interface ExpandablePanelComponentState {
  isOpen: boolean;
  isClosing: boolean;
}

class ExpandablePanelComponent extends React.Component<ExpandablePanelComponentProps, ExpandablePanelComponentState> {
  public static defaultProps: Partial<ExpandablePanelComponentProps> = {
    isOpen: true
  };

  constructor(props: ExpandablePanelComponentProps) {
    super(props);
    this.state = {
      isOpen: props.isOpen,
      isClosing: false
    };
  }

  private onClick = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();

     if (this.state.isOpen) {
      this.setState({ isClosing: true });
        setTimeout(() => {
          this.setState({
            isOpen: false,
            isClosing: false
          });
        }, 300);
     } else {
       this.setState({ isOpen: true });
     }
  };

  public render(): JSX.Element {
    const { expandablePanel, panelHeader, content } = styles;
    const { title, children } = this.props;
    const { isOpen, isClosing } = this.state;
    return (
      <div className={expandablePanel}>
        <button type="button" className={`${panelHeader} ${isOpen && 'active'}`} onClick={this.onClick}>
          {title}
          <FiChevronDown className={isOpen ? 'expand-icon-down' : 'expand-icon-up'} />
        </button>
          <div className={`${content} ${isClosing ? styles.animateOut : ''} ${!isOpen ? styles.hide : ''}`}>
            {children}
          </div>
      </div>
    );
  }
}

export const ExpandablePanel = ExpandablePanelComponent;
